export const AD_CLIENT = 'ca-pub-8326584585992829';

// Existing units retain their reporting history when moving placements.
export const AD_PLACEMENTS = Object.freeze({
  dashboard: { slot: '8430912250', route: 'dashboard' },
  analytics: { slot: '1454440367', route: 'analytics' },
  royalties: { slot: '2951508100', route: 'royalties' },
  catalog: { slot: '7169954710', route: 'ArtistsCatalog' },
  release: { slot: '1223340220', route: 'view-release' },
  blog: { slot: '1037369901', route: 'blog' },
  article: { slot: '1004692263', route: 'blog-post' },
});

const publicRoutes = new Set(['blog', 'blog-post', 'ArtistsCatalog']);
const adRoutes = new Set(Object.values(AD_PLACEMENTS).map(item => item.route));
export const isAdRoute = name => adRoutes.has(name);
export const placementForSlot = slot => Object.entries(AD_PLACEMENTS)
  .find(([, item]) => item.slot === slot)?.[0];

export function canShowAds({ routeName, user, isAuthenticated, initializing, sessionVerified }) {
  if (initializing || !isAdRoute(routeName)) return false;
  if (user?.subscription || user?.freeze || user?.banned) return false;
  if (isAuthenticated || user) return !!(isAuthenticated && user && sessionVerified);
  return publicRoutes.has(routeName);
}

export function isLiveAdEnvironment(hostname, production) {
  return production && ['indiefy.net', 'www.indiefy.net'].includes(hostname);
}
